import React from "react";

export const Proceedings = (props) => {
  return (
    <div id="proceedings" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <h2>Conference Proceedings</h2>
        </div>
        <div className="col-md-10 col-md-offset-1 section-title">
          <a href="pdfs/Proc_11th_Congress_AAAA_2025_Varazdin.pdf">
            The 11th Congress of the Alps Adria Acoustics Association –
            Conference Proceedings
          </a>
        </div>
        <div className="col-md-8 col-md-offset-2 text-justify-xs">
          <div className="proceedings-text">
            <p>Proceedings of previous AAAA Congresses:</p>
            <div id="row ">
              {props.data
                ? props.data.map((d, i) => (
                    <div key={`${d.name}-${i}`}>
                      <div className="thumbnail">
                        <a href={d.link}>{d.name}</a>
                      </div>
                    </div>
                  ))
                : "loading"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
